import React, { useContext, useEffect, useRef, useState } from "react";
import Navbar from "../Navbar";
import NavbarHB from "../NavbarHB";
import Footer from "../Footer";
import Headeraccount from "../Headeraccount";
import { Button, Search, Select, Table, TextBox, ThemeProvider } from '@veneer/core';
import EncodingService from "../api/encoding/EncodingService";
import InlineEdit from "../components/InlineEdit";
import { AuthContext } from "../auth/AuthContext";
import { showToast } from "../components/Toast";
import { filterSort } from "../common";
import { AUTHENTICATED, removeLocalStorageItem } from "../utils/storage-utils";

const StyledTextBox = ({ helperText, error, children, ...props }) => {
    const containerStyle = {
        position: 'relative',
    };
    const helperTextStyle = {
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        paddingTop: '12px ',
        marginTop: '12px',
        fontSize: '14px',
        backgroundColor: '#ffffff',
        border: 'none',
        borderRadius: '4px',
        color: '#000000',
        lineHeight: '1.5',
        display: helperText ? 'flex' : 'none',
        alignItems: 'center',
        gap: '5px',
        zIndex: 10,
        whiteSpace: 'normal', 
        wordWrap: 'break-word', 
        maxWidth: '400px', 
        width: 'max-content', 
        minWidth: '100px' 
    };
const RedCircleIcon = () => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        style={{ minWidth: '18px' }}
    >
        <circle
            cx="12"
            cy="12"
            r="10.5"
            fill="#CC2C00"
            stroke="#CC2C00"
            strokeWidth="1"
        />
        <line
            x1="6"
            y1="12"
            x2="18"
            y2="12"
            stroke="white"
            strokeWidth="1.4"
            strokeLinecap="round"
        />
    </svg>
);
    return (
        <div style={containerStyle}>
            <TextBox {...props} helperText="" style={{
                ...props.style,
                border: helperText ? '1px solid #dc2626' : props.style?.border, 
            }} />
            <div style={helperTextStyle}>
                {helperText && (
                    <>
                        <RedCircleIcon />
                        <span>{helperText}</span>
                    </>
                )}
            </div>
        </div>
    );
};

const Accountmanagement = (props) => {

    const allAccountStatus = [
        {
            label: "Good",
            value: "Good"
        },
        {
            label: "Suspended",
            value: "Suspended"
        },
        {
            label: "Archived",
            value: "Archived"
        }
    ]
    const inputRef1 = useRef();
    const inputRef2 = useRef();
    const inputRef3 = useRef();
    const accountOwnerEmail = '';
    const tempOption = { email: "Unassigned" };

    const [accountName, setAccountName] = useState('');
    const [accountAddress, setAccountAddress] = useState('');
    const [accounts, setAccounts] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [saveAccountErrorMessage, setSaveAccountErrorMessage] = useState('');
    const [validAccountAddress, setValidAccountAddress] = useState(true);
    const [accountAddressErrorMessage, setAccountAddressErrorMessage] = useState('');
    const [accountNameError, setAccountNameError] = useState(false);
    const [accountNameErrorMessage, setAccountNameErrorMessage] = useState('');
    const [accountAddressLengthErrorMessage, setAccountAddressLengthErrorMessage] = useState('');
    const [accountAddressLengthError, setAccountAddressLengthError] = useState(false);
    const [accountNameLengthErrorMessage, setAccountNameLengthErrorMessage] = useState('');
    const [accountNameLengthError, setAccountNameLengthError] = useState(false);
    const [users, setUsers] = useState([]);
    const [status] = useState(allAccountStatus);
    const [buttonStatus, setButtonStatus] = useState(false);
    const [showMsg, setShowMsg] = useState('');
    const [alwaysActiveStatus] = useState([
        {
            label: "Good",
            value: "Good"
        }
    ]);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState(false);
    const [statusChange, setStatusChange] = useState('');
    const [changeOwnerEmail, setChangeOwnerEmail] = useState('');
    const [changeAccountAddress, setChangeAccountAddress] = useState('');
    const [changeAddressFlag, setChangeAddressFlag] = useState(false);
    const [businessNameFilterValue, setBusinessNameFilterValue] = useState('')
    const [accountStatusFilterValue, setAccountStatusFilterValue] = useState([])
    const [orderType, setOrderType] = useState('ascending');
    const [orderBy, setOrderBy] = useState("businessName")
    const [prevAddress, setPrevAddress] = useState("")
    const [prevOwnerEmail, setPrevOwnerEmail] = useState("")
    const [isOwnerEmailChange, setIsOwnerEmailChange] = useState(false)
    const [prevAccountStatus, setPrevAccountStatus] = useState("")
    const [isAccountStatusChange, setIsAccountStatusChange] = useState(false)


    const { uiAccess } = useContext(AuthContext);

    const handleSort = (event, sortBy) => {
        setOrderBy(sortBy.id);
        setOrderType(sortBy.type);
    }

    const filteredData = filterSort(
        accounts,
        {
            businessName: businessNameFilterValue,
            accountStatus: accountStatusFilterValue
        },
        orderBy,
        orderType
    );

    useEffect(() => {
        getAllAccount();
        EncodingService.getAllUser().then((res) => {
            setUsers(res?.data)
        }).catch(() => {
            removeLocalStorageItem(AUTHENTICATED);
            window.location.href = "/supplyencodingsvc/?state=Error";
        });
    }, [])

    const saveAccountDetail = () => {
        setSaveAccountErrorMessage('')
        let returnValue;

        let businessName = accountName;
        let businessAddress = accountAddress;

        const addrRegex = "^[0-9a-zA-Z]+((([ .,-]+)?[0-9a-zA-Z])+[.]?)?$";
        const accountNameRegex = /^[0-9a-zA-Z]+((([ .&,-]+)?[0-9a-zA-Z])+[.]?)?$/g;

        returnValue = true;
        if (businessName.trim() === "") {
            setAccountNameError(true)
            setAccountNameErrorMessage("Please enter Account Name")
            returnValue = false;
        }
        else if (businessName.match(accountNameRegex) === null) {
            setAccountNameError(true)
            setAccountNameErrorMessage("Invalid name. Allowed special characters are & - , . and name must not start or end with a special character.")
            returnValue = false;
        }
        else {
            setAccountNameError(false)
            setAccountNameErrorMessage("")
        }

        if (businessAddress.trim() === "") {
            setValidAccountAddress(false)
            setAccountAddressErrorMessage("Please enter account address")
            returnValue = false;
        } else if (businessAddress.match(addrRegex) === null) {
            setValidAccountAddress(false)
            setAccountAddressErrorMessage("Invalid address. Allowed special characters are - , . and address must not start or end with a special character.")
            returnValue = false;
        } else {
            setValidAccountAddress(true)
            setAccountAddressErrorMessage("")
        }

        if (!returnValue)
            return returnValue;
        let account = {
            businessName: accountName,
            businessAddress: accountAddress,
            ownerEmail: accountOwnerEmail,
            accountStatus: 'New'
        };
        tableData.forEach((item) => {
            if (item.businessName.toLowerCase() === accountName.toLowerCase()) {
                setAccountNameError(true)
                setAccountNameErrorMessage("Name Exists!")
                returnValue = false;
            }
        });

        if (returnValue) {
            setButtonStatus(true)
            EncodingService.addNewAccount(account).then(() => {
                let tableAccount = tableData;
                tableAccount.push(account);
                setTableData(tableAccount)
                setButtonStatus(false)
                setAccountName('')
                setAccountAddress('')
                //props.history.push('/sps-account');
                getAllAccount();
                pageSize === tableData.length - 1 && setPageSize(tableData.length)
                showToast('Account data added Successfully.', 'success')
            }, (error) => {
                setButtonStatus(false)
                setSaveAccountErrorMessage("Error : " + error.response.data.message + ", Response Code : " + error.response.status)
            });

            //DB SAVE Ends ...
        }
        else
            return returnValue;
        setAccountNameError(false)
        setAccountNameErrorMessage('')
        setValidAccountAddress(true)
        setAccountAddressErrorMessage('')
    }

    const handleAccountNameChange = (accountName) => {
    setAccountName(accountName); // Always set the state first
    
    if (accountName.length > 30) {
        setAccountNameLengthError(true);
        setAccountNameLengthErrorMessage("The input character length exceeds the allowed limit.");
    } else {
        setAccountNameLengthError(false);
        setAccountNameLengthErrorMessage("");
    }
    
    // Clear other error states only if there's an error
    if (accountNameError) {
        setAccountNameError(false);
        setAccountNameErrorMessage('');
    }
}

    const handleAccountAddressChange = (accountAddress) => {
    setAccountAddress(accountAddress); // Always set the state first
    
    if (accountAddress.length > 80) {
        setAccountAddressLengthError(true);
        setAccountAddressLengthErrorMessage("The input character length exceeds the allowed limit.");
    } else {
        setAccountAddressLengthError(false);
        setAccountAddressLengthErrorMessage("");
    }
    
    // Clear other error states only if there's an error
    if (!validAccountAddress) {
        setValidAccountAddress(true);
        setAccountAddressErrorMessage('');
    }
}
    const handlePageChange = (page) => {
        setCurrentPage(page)
        getAllAccount();
    }

    const handlePageSizeChange = (event, option) => {
        setPageSize(option.value)
    };

    const handleAddressChange = (e, i) => {
        let arr = filteredData;
        setChangeAccountAddress(e)
        setChangeAddressFlag(true)
        arr[i].businessAddress = e;
        setTableData(arr)
    }

    const handleMailChange = (e, i) => {
        let arr = filteredData;
        setChangeOwnerEmail(e.target.value)
        arr[i].ownerEmail = e.target.value;
        setTableData(arr)
    }

    const handleStatusChange = (e, i) => {
        let arr = filteredData;
        setStatusChange(e.target.value)
        arr[i].accountStatus = e.target.value;
        setTableData(arr)
    }

    const saveBusinessAddress = (e, i) => {
        const isAccountAddressChange = changeAccountAddress !== "" && (prevAddress !== changeAccountAddress)
        const AccountAddressRegex = /^[0-9a-zA-Z]+((([ .,-]+)?[0-9a-zA-Z])+[.]?)?$/g

        let obj = {
            id: tableData[i].id,
            businessAddress: changeAccountAddress
        }
        if (obj.businessAddress === "") {
            showToast("Please enter account address value.", 'error')
            getAllAccountInline();
        }
        else if (obj.businessAddress.match(AccountAddressRegex) === null) {
            showToast("Not a valid account address.", 'error')
            getAllAccountInline();
        }
        else if (obj.businessAddress.length > 79) {
            showToast("Character limit of 80 exceeded.", 'error')
            getAllAccountInline();
        }
        if (isAccountAddressChange) {
            if (obj.businessAddress.match(AccountAddressRegex) !== null && obj.businessAddress.match(AccountAddressRegex).length !== 0 && obj.businessAddress.length < 80) {
                setShowMsg("show")

                EncodingService.updateBusinessAddress(obj).then(() => {
                    showToast("Business address updated successfully.", 'success')
                    getAllAccount();
                })
            }
        }
        setChangeAddressFlag(false)
    }

    const saveBusinessMail = (e, i) => {
        const isMailChange = changeOwnerEmail && prevOwnerEmail !== changeOwnerEmail
        isMailChange && setIsOwnerEmailChange(true)
        let mail = (e.target.value).toString();
        let obj = {
            id: tableData[i].id,
            ownerEmail: changeOwnerEmail
        }
        if (isMailChange) {
            if (mail === "Unassigned") {
                EncodingService.updateClearBusinessOwner(obj).then(() => {
                    showToast("Cleared owner email successfully.", 'success')
                    getAllAccountInline();
                }, (error) => {
                    showToast("Failed to clear the owner email", 'error')
                });
            } else {
                EncodingService.updateBusinessMail(obj).then(() => {
                    showToast("Business email updated successfully.", 'success')
                    getAllAccount();
                }, (error) => {
                    showToast("Business email failed to update.", 'error')
                })
            }
        }
        setPrevOwnerEmail("")
        setChangeOwnerEmail("")
    }

    const saveBusinessStatus = (e, i) => {
        const isStatusChange = statusChange && prevAccountStatus !== statusChange
        isStatusChange && setIsAccountStatusChange(true)
        let status = statusChange.toString();

        let obj = {
            id: tableData[i].id,
            accountStatus: status
        }
        if (isStatusChange) {
            EncodingService.updateBusinessStatus(obj).then(() => {
                showToast("Business status updated successfully.", 'success')
                getAllAccount();
            }, (error) => {
                showToast("Business status failed to update.", 'error')
            })
        }
        setPrevAccountStatus("")
        setStatusChange("")
    }

    const getAllAccountInline = () => {
        EncodingService.getAllAccount().then((res) => {
            setAccounts(res?.data)
            setTableData(res?.data)
        });
    }

    const getAllAccount = () => {
        setLoading(true)
        EncodingService.getAllAccount().then((res) => {
            setAccounts(res?.data)
            setTableData(res?.data)
            if (res.data) {
                setLoading(false)
            }
        }).catch(() => {
            removeLocalStorageItem(AUTHENTICATED);
            window.location.href = "/supplyencodingsvc/?state=Error";
        });
    }

    const handleBusinessNameFilterValue = (value) => {
        setBusinessNameFilterValue(value);
        setCurrentPage(1);
    };
    const handleAccountStatusFilterValue = (e) => setAccountStatusFilterValue([e.value]);

    const columns = [
        {
            id: 'businessName',
            label: 'ACCOUNT NAME',
            filter: (
                <Search
                    label="Search"
                    placeholder="Placeholder"
                    id="table-filter-businessName"
                    className={'table-filter-businessName'}
                    value={businessNameFilterValue}
                    onClear={() => setBusinessNameFilterValue('')}
                    onChange={handleBusinessNameFilterValue}
                />
            )
        }, {
            id: 'businessAddress',
            label: 'ACCOUNT ADDRESS',
            sortable: false
        }, {
            id: 'ownerEmail',
            label: 'OWNER EMAIL'
        }, {
            id: 'accountStatus',
            label: 'ACCOUNT STATUS',
            filter: (
                <Select
                    label="Select Status"
                    id="table-filter-accountStatus"
                    className={'table-filter-accountStatus'}
                    options={allAccountStatus}
                    onClear={() => setAccountStatusFilterValue([])}
                    onChange={handleAccountStatusFilterValue}
                    value={accountStatusFilterValue}
                />
            ),
        }
    ]


    return (
        <div>
            <Headeraccount />
            {uiAccess?.navbarHB && <NavbarHB role={props.role} />}
            {uiAccess?.navbarSPS && <Navbar role={props.role} />}
            <div className="tableWrapper">
                <form >
                    <div className="row p-40">
                        <div className="col-md-12">
                            <div className="p-r-40">
                                <div className="row">
                                    <div className="col-md-5">
                                        <h4 className="subtitle-large p-b-20">Add New Account:</h4>
                                    </div>
                                    <div className="col-md-7">
                                    </div>
                                </div>
                                <div className="row align-items-end">
                                    <div className="col-md-2">
                                        <label className="font-text">Account Name*</label>
                                    </div>
                                    <div className="col-md-3">
                                        <ThemeProvider mode="light" shape="round" density="high" id="accountNameLabel">
                                            <StyledTextBox
                                                density="high"
                                                id="accountName"
                                                className="text-l input-text"
                                                name="accountName"
                                                required
                                                label="Required field"
                                                value={accountName}
                                                onChange={(accName) => handleAccountNameChange(accName)}
                                                placeholder=""
                                                maxLength={31}
                                                helperText={accountNameLengthError ? accountNameLengthErrorMessage : accountNameErrorMessage}
                                                error={accountNameLengthError || accountNameError}
                                                style={{ height: '2rem' }}
                                            />
                                        </ThemeProvider>
                                    </div>
                                    <div className="col-md-2">
                                        <span id="reqTxtName" className="reqError req-error"></span>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <br></br>
                                <div className="row align-items-end" >
                                    <div className="col-md-2">
                                        <label className="font-text" >Account Address*</label>
                                    </div>
                                    <div className="col-md-3">
                                        <ThemeProvider mode="light" shape="round" density="high"
                                            id="accountAddresslabel">
                                            <StyledTextBox
                                                density="high"
                                                id="accountAddress"
                                                className="text-l input-text"
                                                name="accountAddress"
                                                required
                                                label="Required field"
                                                value={accountAddress}
                                                onChange={(accAddress) => handleAccountAddressChange(accAddress)}
                                                placeholder=""
                                                maxLength={81}
                                                helperText={accountAddressLengthError ? accountAddressLengthErrorMessage : accountAddressErrorMessage}
                                                error={accountAddressLengthError || !validAccountAddress}
                                                style={{ height: '2rem' }}
                                            />
                                        </ThemeProvider>
                                    </div>
                                    <div className="col-md-2">
                                        <span id="reqTxtAddress" className="reqError req-error"></span>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row" style={{
                                    marginTop: accountAddressErrorMessage === "Invalid address. Allowed special characters are - , . and address must not start or end with a special character." ? '30px' : '0px'
                                }}>
                                    <div className="col-md-5 offset-md-6">
                                        <Button loading={buttonStatus} className="button-p" onClick={saveAccountDetail} id={"saveAccountDetail"}>Save</Button>
                                    </div>
                                </div>
                                <span className="errormsg p-l-0">{saveAccountErrorMessage}</span>
                            </div>
                        </div>
                    </div>
                </form>
                <div className="row justify-content-start">
                    <div className="col-md-11">
                        <br></br>
                        <br></br>
                        <h5 className="subtitle-large mb-3">Current Accounts:</h5>
                        <Table
                            showFilters
                            loading={loading}
                            columns={columns}
                            columnResize={true}
                            id={'currentAccountsTable'}
                            onSort={handleSort}
                            preferences={{
                                sortBy:
                                {
                                    id: orderBy,
                                    type: orderType
                                }
                            }}
                            data={accounts ? filteredData.map((data, i) => {
                                let alwaysActiveStatusCheck = data.businessName === "SPTS" || data.businessName === "HP"
                                return {
                                    businessName: data.businessName,
                                    businessAddress:
                                        <InlineEdit
                                            text={data.businessAddress}
                                            placeholder={data.businessAddress}
                                            type="input"
                                            childRef={inputRef1}
                                            onClick={() => setShowMsg("")}
                                            msg={showMsg}
                                        >
                                            <TextBox
                                                ref={inputRef1}
                                                density="High"
                                                className="inlineText"
                                                name="businessAddress"
                                                onFocus={(e) => setPrevAddress(e.target.value)}
                                                onChange={(e) => handleAddressChange(e, i)}
                                                onBlur={(e) => changeAddressFlag && saveBusinessAddress(e, i)}
                                                value={changeAddressFlag ? changeAccountAddress : data.businessAddress}
                                                maxLength={80}
                                                placeholder=""
                                            />
                                        </InlineEdit>,
                                    ownerEmail:
                                        <InlineEdit
                                            text={data.ownerEmail || 'Unassigned'}
                                            placeholder={data.ownerEmail || 'Unassigned'}
                                            type="input"
                                            childRef={inputRef2}
                                            onClick={() => setIsOwnerEmailChange(false)}
                                            msg={isOwnerEmailChange ? "show" : ""}
                                        >
                                            <select
                                                ref={inputRef2}
                                                className="inlineSelect"
                                                name="ownerEmail"
                                                value={data.ownerEmail || 'Unassigned'}
                                                onFocus={(e) => setPrevOwnerEmail(e.target.value)}
                                                onChange={(e) => handleMailChange(e, i)}
                                                onBlur={(e) => saveBusinessMail(e, i)}
                                            >

                                                {[tempOption].concat(users.filter(e => e.businessName === data.businessName && (e.role === 'Administrator' || e.role === 'SPTS Administrator'))).map(e => (
                                                    <option key={e.email} value={e.email}>
                                                        {e.email}
                                                    </option>
                                                ))}
                                            </select>
                                        </InlineEdit>,
                                    accountStatus:
                                        <InlineEdit
                                            text={data.accountStatus || 'Unassigned'}
                                            placeholder={data.accountStatus || 'Unassigned'}
                                            type="input"
                                            childRef={inputRef3}
                                            onClick={() => setIsAccountStatusChange(false)}
                                            msg={isAccountStatusChange ? "show" : ""}
                                        >
                                            <select
                                                ref={inputRef3}
                                                className="inlineSelect"
                                                name="accountStatus"
                                                value={data.accountStatus || 'Unassigned'}
                                                onFocus={(e) => setPrevAccountStatus(e.target.value)}
                                                onBlur={(e) => saveBusinessStatus(e, i)}
                                                onChange={(e) => handleStatusChange(e, i)}>

                                                {alwaysActiveStatusCheck ? alwaysActiveStatus.map((e) => (

                                                    <option key={e.value} value={e.value}>
                                                        {e.value}
                                                    </option>

                                                )) : status.map((e) => (
                                                    <option key={e.value} value={e.value}>
                                                        {e.value}
                                                    </option>
                                                ))
                                                }

                                            </select>
                                        </InlineEdit>
                                    ,
                                };
                            }).slice((currentPage - 1) * pageSize, (currentPage - 1) * pageSize + pageSize)
                                : null}
                            pagination={{
                                currentPage: currentPage,
                                pageSizeOptions: filteredData.length <= 2 ? [{ value: filteredData.length }] :
                                    filteredData.length < 5 ? [{ value: 2 }, { value: filteredData.length }] :
                                        filteredData.length <= 8 ? [{ value: 2 }, { value: 4 }, { value: filteredData.length }] :
                                            filteredData.length <= 9 ? [{ value: 2 }, { value: 4 }, { value: 8 }, { value: filteredData.length }] :
                                                filteredData.length <= 10 ? [{ value: 2 }, { value: 4 }, { value: 8 }, { value: filteredData.length }] : [{ value: 2 }, { value: 4 }, { value: 8 }, { value: 10 }, { value: filteredData.length }],
                                onPageChange: handlePageChange,
                                onPageSizeChange: handlePageSizeChange,
                                totalItems: filteredData.length,
                                pageSize: pageSize
                            }}
                        />
                    </div>

                    <br></br>
                    <br></br>
                </div>
            </div>
            <div className="modal fade account-update"
                id="staticBackdrop" data-backdrop="static" data-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true"
            >
            </div>
            <Footer />
        </div>
    ); 
}

export default Accountmanagement;